// api
import { createFeedbackClient } from "../../api/clientFactory";
import * as Client from "../../api/Client";
import { call } from "../../api/callHelper";
// me
import { IRootViewModel } from "./models/models";

export async function initialise(updateVm: React.Dispatch<React.SetStateAction<IRootViewModel>>): Promise<void> {
    updateVm((vm) => vm.referenceDataLoading());

    const client = createFeedbackClient();
    const request = new Client.GetCreatePublicFeedbackReferenceDataRequestDto();
    const result = await call(() => client.getCreatePublicFeedbackReferenceData(request));

    updateVm((vm) => vm.referenceDataLoaded(result.Response, result.Error));
}

export async function createFeedbackRequest(vm: IRootViewModel, updateVm: React.Dispatch<React.SetStateAction<IRootViewModel>>): Promise<void> {
    updateVm((vm) => vm.feedbackRequestCreating());

    const client = createFeedbackClient();
    const request = new Client.CreatePublicFeedbackRequestDto({
        userToken: vm.userToken,
        honorificId: vm.feedback.honorific?.id,
        customerFirstName: vm.feedback.customerFirstName!,
        customerLastName: vm.feedback.customerLastName!,
        customerCompanyName: vm.feedback.customerCompanyName,
        customerContactNumber: vm.feedback.customerContactNumber!,
        customerEmailAddress: vm.feedback.customerEmailAddress!,
        feedbackTypeId: vm.feedback.feedbackType!.id,
        nopimsActivityTypeId: vm.feedback.nopimsActivityType?.id,
        activityId: vm.feedback.activity?.id,
        dataMonitoringItemTypeId: vm.feedback.dataMonitoringItemType?.id,
        customerComments: vm.feedback.customerComments!,
    });
    const result = await call(() => client.createPublicFeedback(request));

    updateVm((vm) => vm.feedbackRequestCreated(result.Response, result.Error));
}
